(function () {
    const $body = $('body'),
        binders = {
            $removeEl: null,
            removeLink: null,
            isItem: false,
            $alertMsg: $('.binder-list__alerts__msg'),
            successHtml: `<p class="alert-msg alert-msg--success"><i class="icon-checkmark"></i>{message}</p>`,
            warningHtml: `<p class="alert-msg alert-msg--warning"><i class="icon-warning-triangle"></i>{message}</p>`,

            init() {
                this._share.init();
                this._create.init();
                this.control();
            },

            control() {
                $body.on('click', '.binder__tools__remove', e => {
                    let $target = $(e.target).hasClass('binder__tools__remove')
                        ? $(e.target)
                        : $(e.target).closest('.binder__tools__remove');
                    this.removeConfirmation($target);
                });

                $body.on('click', '.binder__remove__confirm', e => {
                    e.preventDefault();
                    this.remove();
                });

                $body.on('click', '.binder__share-invitation__reject, .binder__share-invitation__accept', e => {
                    e.preventDefault();
                    let $this =
                            $(e.target).hasClass('binder__share-invitation__reject') ||
                            $(e.target).hasClass('binder__share-invitation__accept')
                                ? $(e.target)
                                : $(e.target).parent(),
                        isAccept = true;
                    if ($this.is('.binder__share-invitation__reject')) {
                        isAccept = false;
                    }
                    this.responseInvitation($this, isAccept);
                });

                this.clickableRow();
            },

            removeConfirmation($el) {
                this.$removeEl = $el;
                this.removeLink = binders.$removeEl.attr('data-remove-link'); // real link
                // this.removeLink = '/specs/ux3/widgets/binder-list/templates/demo/remove.json'; // test link

                this.isItem = !!this.$removeEl.is('.remove-binder-item');

                $('#removeBinder')
                    .find('.type')
                    .html(this.isItem ? 'item' : 'binder');
            },
            remove() {
                $.ajax({
                    url: this.removeLink,
                    type: 'GET',
                    success: function (data) {
                        if (data.message) {
                            binders.$alertMsg.html(binders.successHtml.replace(/{message}/g, data.message));

                            if (binders.isItem) {
                                binders.$removeEl.closest('.issue-item').parent('li').remove();
                            } else {
                                binders.$removeEl.closest('tr').remove();
                            }
                        }

                        if (typeof binders.$removeEl.attr('data-redirectLink') !== 'undefined') {
                            location.href = binders.$removeEl.attr('data-redirectLink');
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON.message) {
                            binders.$alertMsg.html(
                                binders.warningHtml.replace(/{message}/g, data.responseJSON.message)
                            );
                        }
                    },
                });

                $('#removeBinder').modal('toggle');
                $body.removeAttr('data-active');
                setTimeout(function () {
                    binders.$alertMsg.html('');
                }, 3000);
            },

            responseInvitation($el, isAccept) {
                let link = $el.attr('href'),
                    binderCode = $el.closest('tr').data('code');

                // if (isAccept) {
                //     link = '/specs/ux3/widgets/binder-list/templates/demo/accept.json'; // test link
                // } else {
                //     link = '/specs/ux3/widgets/binder-list/templates/demo/reject.json'; // test link
                // }

                $.ajax({
                    url: link,
                    type: 'GET',
                    success: function (data) {
                        if (data) {
                            if (isAccept) {
                                binders._create.generateBinder(data, true);
                            }
                            if (data.message) {
                                binders.$alertMsg.html(binders.successHtml.replace(/{message}/g, data.message));
                            }

                            if ($('.alert-msg--error').length) {
                                $('.alert-msg--error').each(function () {
                                    let $this = $(this),
                                        errorMessageCode = $this.data('binder-code');

                                    if (binderCode === errorMessageCode) {
                                        $this.remove();
                                    }
                                });
                            }

                            $el.closest('tr').remove();
                            if ($('.binder__share-invitation').find('tr').length <= 1) {
                                $('.binder__share-invitation').remove();
                            }
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON && data.responseJSON.message) {
                            binders.$alertMsg.html(
                                binders.warningHtml.replace(/{message}/g, data.responseJSON.message)
                            );
                        }
                    },
                });
            },
            clickableRow() {
                $(document).on('click', '.clickable-row', function (e) {
                    if (!$(e.target).parents('.binder__tools').length) {
                        window.location.href = $(this).attr('data-link');
                    }
                });
            },
        };

    UX.binders = binders; // add to global namespace
    $(document).ready(function () {
        if ($('.binder').length) {
            UX.binders.init();
        }
    });
})();
